// @flow
import React, { PureComponent } from 'react';
import type { FullUserType } from 'types/User';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { socialNetworks } from 'utils/socialShareUtils';

type Props = {
  url: string,
  title: string,
  userPref: FullUserType
};

class ArticleSocial extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    title: ''
  };

  renderButtons = (): Array<React$Element<any>> => {
    const { url, title, userPref } = this.props;

    return Object.keys(socialNetworks).map(key => {
      const ShareButton = socialNetworks[key];
      let classNames = key === 'mail' ? 'btn btn--social btn--medium btn--primary btn--social' : 
      `btn btn--social btn--medium btn--${key} btn--social`;
      if (key === 'twitter') {
        classNames += ' btn--x is-dark';
      }
      const data = {
        className: classNames,
        url: (!url || url === '#' ) ? window.location.href : url,
        quote: (key === 'facebook') ? title : false,
        title: (key === 'twitter' || 'whatsapp') ? title : false,
        subject: (key === 'mail') ? title : false,
      };

      return (
        <ShareButton
          {...data}
          key={`${key}-share-button`}
          beforeOnClick={handleTagEvent(
            'peut ',
            title,
            key,
            userPref
          )}>
          <i className={`icon icon-${key}`} />
        </ShareButton>
      );
    });
  }

  render() {
    return (
      <div className="article__social">
       {this.renderButtons()}
      </div>
    );
  }
}

export default ArticleSocial;
